import api from '@/utils/api';

const state = {
    bankAccountOptions: [],
};

const getters = {
    bankAccountOptions: (state) => state.bankAccountOptions,
};

const actions = {
    updateBankAccountOptions({ commit }) {
        return new Promise((resolve, reject) => {
            api({ url: 'Tool/GetBankAccountOptions', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_bankAccountOptions', resp.data.options);
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    update_bankAccountOptions(state, options) {
        state.bankAccountOptions = options;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
